import { CodeSection } from './code-subject-section';

export const CodeSectionEnteDichiarante = [
  CodeSection.CONSENSO_MADRE,
  CodeSection.CONSENSO_PADRE,
  CodeSection.DATI_ATTO_TRASCRIZIONE,
  CodeSection.DATI_AUTORITA_MITTENTE,
  CodeSection.DATI_TRASCRIZIONE_AUTORITA_MITTENTE,
  CodeSection.DATI_PROVCOM,
  CodeSection.PROVVEDIMENTO_MIN_INTER,
  CodeSection.DECRETO_INTIMAZIONE,
  CodeSection.SENTENZA_ADOZIONE,
  CodeSection.SENTENZA_REVOCA_ADOZIONE,
  CodeSection.DATI_SERVIZIO_MILITARE,
  CodeSection.ATTO_DI_CONSENSO_ED,
  CodeSection.CONSENSO_SENTENZA,
  CodeSection.SENTENZA_CONSENSO,
  CodeSection.CONSENSO_ALTRO,
  CodeSection.DATI_PROVVEDIMENTO_SINDACO,
  CodeSection.ESTREMI_SENTENZA_MADRE,
  CodeSection.ESTREMI_SENTENZA_PADRE,
  CodeSection.DATI_ACCERTAMENTO,
  CodeSection.DATI_ACCERTAMENTO_BIS,
  CodeSection.SENTENZA_MORTE_PRESUNTA,
  CodeSection.SENTENZA_ACCERTAMENTO_MORTE_PRESUNTA,
  CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO,
  CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA,
  CodeSection.MATRIMONIO_SENTENZA_OMISSIONE_PUBBLICAZIONE,
  CodeSection.PROVVEDIMENTO_RIGETTO_OPPOSIZIONE,
  CodeSection.MATRIMONIO_ESTINZIONE_RIGETTO_OPPOSIZIONE,
  CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIFETTO_ETA,
  CodeSection.MATRIMONIO_AUTORIZZAZIONE_PARENTELA,
  CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIVIETO_TEMP,
  CodeSection.PROVVEDIMENTO_ESTINZIONE_OPPOSIZIONE,
  CodeSection.PROVVEDIMENTO_RIGETTO_OPPOSIZIONE,
  CodeSection.PROVVEDIMENTO_SEPARAZIONE,
  CodeSection.DATI_SENTENZA_ECCLESIASTICA,
  CodeSection.ENTE_DICHIARANTE,
];
